import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type { ColorScheme }

export type PopoverPlacement =
  | 'bottom-start'
  | 'bottom-end'
  | 'top-start'
  | 'top-end'
  | 'left-start'
  | 'right-start'

// Absolute offset of the panel relative to its trigger wrapper, per placement.
// The wrapper is `position: relative`, so these anchor the panel to a corner of
// the trigger and nudge it away by a small gap.
export const placementStyles: Record<PopoverPlacement, SystemStyleObject> = {
  'bottom-start': { top: '100%', left: 0, mt: '8px' },
  'bottom-end': { top: '100%', right: 0, mt: '8px' },
  'top-start': { bottom: '100%', left: 0, mb: '8px' },
  'top-end': { bottom: '100%', right: 0, mb: '8px' },
  'left-start': { right: '100%', top: 0, mr: '8px' },
  'right-start': { left: '100%', top: 0, ml: '8px' },
}

const tokens = (colorScheme: ColorScheme) => {
  const prefix = colorScheme === 'light' ? 'light.' : ''
  return {
    bg: `${prefix}bg.card`,
    border: `${prefix}border.subtle`,
    closeColor: `${prefix}icon.secondary`,
  }
}

export const popoverContentStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => {
  const t = tokens(colorScheme)
  return {
    position: 'absolute',
    bg: t.bg,
    border: '1px solid',
    borderColor: t.border,
    borderRadius: '12px',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.2)',
    // Panels portal to <body>, escaping any Soehne-setting ancestor (e.g. a
    // Modal body), so anchor the base font here. Emphasis text overrides with
    // Soehne Kraftig.
    fontFamily: "'Soehne', sans-serif",
  }
}

export const popoverCloseButtonStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  position: 'absolute',
  top: '12px',
  right: '12px',
  alignItems: 'center',
  bg: 'transparent',
  border: 'none',
  color: tokens(colorScheme).closeColor,
  cursor: 'pointer',
  display: 'inline-flex',
  justifyContent: 'center',
  p: '4px',
})
